"use client";

import { useRouter } from "next/navigation";

import AuthForm from "@client/components/auth-form";

export default function PremiumLoginOverlay() {
  const router = useRouter();

  return (
    <div className="premium-login-overlay" data-spec="premium-login-overlay">
      <AuthForm
        createAccountHref="/create-account"
        onSuccess={() => {
          router.refresh();
        }}
        variant="log-in"
      />
    </div>
  );
}
